<template>
  <div>
    <v-row no-gutters md="8" class="bottom-border">
      <v-col xs="8" sm="8" md="8" lg="8" xl="8">
        <div class="news-chart ">
          <div class="text-body text-center font-weight-bold">
            <span class="font-size-title"> {{ $t("marketMonitor.news") }}</span>
          </div>

          <div
            v-if="false"
            class="loading-indicator d-flex justify-center align-center flex-gow-1"
          >
            <v-progress-circular
              indeterminate
              color="primary"
              :size="50"
              :width="5"
            >
            </v-progress-circular>
            <span class="ml-3 text-h4">{{ $t('extras.loadingDot') }}</span>
          </div>

          <div
            class="grow over"
            style="overflow-y: hidden; height: 23vh"
            v-if="true"
          >
            <news-chart :slides="getFxMarketNews"></news-chart>
          </div>
          <view-more link="" :next-link="false"/>
        </div>
      </v-col>

      <v-col md="4" sm="4" lg="4" xs="4">
        <div class="p-chart mx-5 ">
          <div class="text-body text-center font-weight-bold">
            <span class="font-size-title">{{
              $t("marketMonitor.currencyPair")
            }}</span>
          </div>
          <div
            class="d-flex justify-center flex-column pt-3"
            style="overflow-y: auto"
          >
            <the-currency-chart />
          </div>
            <view-more :next-link="true" link="/nexus"/>
        </div>
      </v-col>
    </v-row>
    <div class="border-calendar"></div>
    <v-row>
      <v-col xs="8" sm="8" md="8" lg="8" xl="8" class="mt-3 px-0">
        <div class="economic-calendar">
          <div class="text-body text-center font-weight-bold pb-3">
            <span class="font-size-title"
              >{{ $t("marketMonitor.economicCalendar") }}
            </span>
          </div>
          <div
            class="flex-grow-1 d-flex"
            style="overflow-y: hidden; height: 44vh"
          >
            <the-economic-calendar class="mx-7" style="width: 100%" />
          </div>
          <view-more :next-link="false" link=""/>
        </div>
      </v-col>

      <v-col md="4" sm="4" lg="4" xs="4">
        <!--cross quotes (top col-2)-->
        <div class="cross-quotes mx-3 pt-2">
          <div class="text-body text-center font-weight-bold">
            <span class="font-size-title">
              {{ $t("marketMonitor.crossQuotes") }}
            </span>
          </div>
          <div>
            <the-cross-quote-table></the-cross-quote-table>
          </div>
          <view-more :next-link="true" link="/nexus"/>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapState } from "pinia";
import NewsChart from "./NewsChart.vue";
import TheCrossQuoteTable from "./TheCrossQuoteTable.vue";
import TheCurrencyChart from "./TheCurrencyChart.vue";
import { useFxMarketStore } from "@/store";
import TheEconomicCalendar from "./TheEconomicCalendar.vue";
import ViewMore from "../common/ViewMore.vue";

export default {
  components: {
    TheCrossQuoteTable,
    NewsChart,
    TheCurrencyChart,
    TheEconomicCalendar,
    ViewMore
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(useFxMarketStore, [
      "getFxMarketIntradayData",
      "getFxMarketEconomicCalendar",
      "getFxMarketNews",
      "getFxMarketDailyData",
      "getFxMarketIsLoading",
    ]),
  },
};
</script>
<style scoped>
.difference-values {
  padding-top: 0.5rem;
  line-height: 0.15rem;
}
.view-more {
  display: flex;
}
.font-size-title {
  font-size: var(--news-font-size) !important;
}

.economic-calendar,
.p-chart,
.cross-quotes,
.news-chart {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: 100% !important;
}

.bottom-border {
  border-bottom: 1px solid #3d3d3d;
}

.border-calendar {
  position: fixed;
  right: 33%;
  top: 0%;
  height: 100%;
  border-right: 1px solid #3d3d3d;
}

.ui-row {
  min-height: 0;
  flex: 1 1 25vh;
  height: 27vh;
}
.ui-row:first-of-type {
  flex: 0.5 1 50%;
}

.ui-row:last-of-type {
  flex: 1.5 1 50%;
}
.ui-col {
  flex: 1 1 50% !important;
  display: flex;
  flex-direction: column;
}
.chart {
  max-width: 1940px;
  /* width: 1940px; */
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.disable-focus:focus::before {
  opacity: 0 !important;
}
::v-deep .v-tabs-bar {
  width: 100% !important;
  padding: 0 !important;
  background: transparent !important;
}
::v-deep .v-slide-group__content {
  justify-content: center !important;
}
::v-deep .spotlight {
  background: rgba(255, 255, 255, 0.15) !important;
  backdrop-filter: blur(3.8px) !important;
  -webkit-backdrop-filter: blur(3.8px) !important;
  border: thin solid rgba(255, 255, 255, 0.4);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}
</style>
